"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextUtil = void 0;
// Create JSONLD Shorthands
var shorthandToIriMap = {
    "@type": "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
};
/**
 * Context Util
 * Handles the JSON-LD context and allows conversion between IRIs and terms
 */
var ContextUtil = /** @class */ (function () {
    function ContextUtil(context) {
        var _this = this;
        this.context = context;
        this.iriToKeyMap = {};
        Object.entries(context).forEach(function (_a) {
            var _b = __read(_a, 2), contextKey = _b[0], contextValue = _b[1];
            if (typeof contextValue === "string") {
                _this.iriToKeyMap[_this.keyIdToIri(contextValue)] = contextKey;
            }
            else if (typeof contextValue === "object" &&
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                contextValue["@id"]) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                _this.iriToKeyMap[_this.keyIdToIri(contextValue["@id"])] =
                    contextKey;
            }
        });
    }
    ContextUtil.prototype.keyToIri = function (key) {
        if (!this.context[key]) {
            return key;
        }
        else if (typeof this.context[key] === "string") {
            return this.keyIdToIri(this.context[key]);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        else if (this.context[key] && this.context[key]["@id"]) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return this.keyIdToIri(this.context[key]["@id"]);
        }
        return key;
    };
    ContextUtil.prototype.keyIdToIri = function (keyId) {
        if (shorthandToIriMap[keyId]) {
            return shorthandToIriMap[keyId];
        }
        else {
            return keyId;
        }
    };
    ContextUtil.prototype.iriToKey = function (iri) {
        if (this.iriToKeyMap[iri]) {
            return this.iriToKeyMap[iri];
        }
        return iri;
    };
    ContextUtil.prototype.getType = function (key) {
        if (typeof this.context[key] === "object" &&
            this.context[key]["@type"]) {
            return this.context[key]["@type"];
        }
        return "http://www.w3.org/2001/XMLSchema#string";
    };
    ContextUtil.prototype.isArray = function (key) {
        return !!(this.context[key] &&
            typeof this.context[key] === "object" &&
            this.context[key]["@container"] &&
            this.context[key]["@container"] === "@set");
    };
    return ContextUtil;
}());
exports.ContextUtil = ContextUtil;
